module.exports = __webpack_public_path__ + "img/VIP-2.e874dd0f.png";